import React from "react";

export const BRAND_ORANGE = "#E97B2B";

// Official BASE logo files (orange house replaces the "A")
const LOGO_GREY =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/wvd8xwdq_logo-no-tag.png"; // grey letters — for light backgrounds
const LOGO_WHITE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_exact-copy-build/artifacts/yoyvgnvt_logo-white-no-tag.png"; // white letters — for dark backgrounds

// `dark` = true when placed on a LIGHT background (use grey-letter logo)
const BaseLogo = ({ dark = false, size = 26 }) => (
  <img
    src={dark ? LOGO_GREY : LOGO_WHITE}
    alt="BASE"
    style={{ height: `${size}px`, width: "auto", display: "block" }}
  />
);

export default BaseLogo;
